import { render, staticRenderFns } from "./FacebookManagement.vue?vue&type=template&id=1d461542&scoped=true"
import script from "./FacebookManagement.vue?vue&type=script&lang=js"
export * from "./FacebookManagement.vue?vue&type=script&lang=js"
import style0 from "./FacebookManagement.vue?vue&type=style&index=0&id=1d461542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d461542",
  null
  
)

export default component.exports